export type RoutePath = '/' | '/asetukset' | '/info' | '/pasihyppely' | '/sotilasarvot'

export const routes: RoutePath[] = ['/', '/asetukset', '/info', '/pasihyppely', '/sotilasarvot']

export default routes
